<template>
    <tr :class="rowClass">
        <!-- able to select row -->
        <td
            v-if="prepend"
            class="row-checkbox-cell"
        ></td>

        <template v-for="column in columns">
            <td
                :class="[column.id.replace('_', '-'), column.type + '-cell', 'is-collapsible']"
                :key="column.id"
                v-if="!column.disabled"
                v-show="column.visible"
            >
                <template v-if="true == column.editable">
                    <bo-cell-number
                        v-if="'number' == column.type"
                        :id="column.id"
                        :value="item[column.id]"
                        :meta="column.meta"
                        :editable="column.editable"
                        @change="
                            item[column.id] = $event;
                            $emit('change', item, column.type);
                        "
                    >
                    </bo-cell-number>

                    <bo-cell-currency
                        v-else-if="'currency' == column.type"
                        :id="column.id"
                        :currency="'RM'"
                        :value="item[column.id]"
                        :meta="column.meta"
                        :editable="column.editable"
                        @change="
                            item[column.id] = $event;
                            $emit('change', item, column.type);
                        "
                    >
                    </bo-cell-currency>

                    <bo-cell-attachment
                        v-else-if="'attachment' == column.type"
                        :value="item[column.id]"
                        :id="column.id"
                        :editable="column.editable"
                        @change="$emit('change', item, column.type)"
                        @loading="$emit('loading')"
                        @done_loading="$emit('done_loading')"
                    >
                    </bo-cell-attachment>

                    <bo-cell-status
                        v-else-if="'status' == column.type"
                        :value="item[column.id]"
                        :id="column.id"
                        :editable="column.editable"
                        :editableCondition="column.editableCondition"
                        :options="column.options"
                        @change="
                            item[column.id] = $event;
                            $emit('change', item, column.type);
                        "
                    >
                    </bo-cell-status>

                    <bo-cell-product
                        v-else-if="'product' == column.type"
                        :ref="'assignProduct_' + id"
                        :id="column.id"
                        :parentId="id"
                        :value="item[column.id]"
                        :editable="column.editable"
                        :getProductUrl="column.url.advanceSearchProductUrl"
                        :getProductOptionsUrl="column.advanceSearchProductOptionsUrl"
                        :columns="column.advanceSearchColumns"
                        @change="
                            item[column.id] = $event;
                            $emit('change', item, column.type);
                        "
                    ></bo-cell-product>

                    <bo-cell-multiselect
                        v-else-if="'multiselect' == column.type"
                        :ref="'assignMultiselect_' + id"
                        :id="column.id"
                        :title="resolvePlaceholders(column.title, item)"
                        :subtitle="column.subtitle"
                        :parentId="id"
                        :value="item[column.id]"
                        :meta="column.meta"
                        :editable="column.editable"
                        :getItemsUrl="resolveURL(column.url.getItemsUrl, item)"
                        :columns="column.meta.addItemsColumns"
                        @change="
                            item[column.id] = $event;
                            $emit('change', item, column.type);
                        "
                    ></bo-cell-multiselect>

                    <bo-cell-per-total
                        v-else-if="'per_total' == column.type"
                        :ref="'perTotal_' + id"
                        :id="column.id"
                        :parentId="id"
                        :meta="column.meta"
                        :editable="column.editable"
                        :value="item[column.id]"
                        @change="
                            item[column.id] = $event;
                            $emit('change', item, column.type);
                        "
                    >
                    </bo-cell-per-total>

                    <bo-cell-mode-input-number
                        v-else-if="'mode_input_number' == column.type"
                        :id="column.id"
                        class="form-control"
                        :value="item[column.id].value"
                        :options="item[column.id].options"
                        :selected="item[column.id].selected"
                        :meta="column.meta"
                        :editable="column.editable"
                        @value_change="
                            item[column.id].value = $event;
                            $emit('change', item, column.type);
                        "
                        @selected_change="
                            item[column.id].selected = $event;
                            $emit('change', item, column.type);
                        "
                    >
                    </bo-cell-mode-input-number>

                    <input
                        v-else
                        type="text"
                        v-model="item[column.id]"
                        @change="$emit('change', item, 'default')"
                    />
                </template>

                <!-- if data cannot edit -->
                <template v-else>
                    <bo-cell-status
                        v-if="'status' == column.type"
                        :value="item[column.id]"
                    >
                    </bo-cell-status>

                    <bo-cell-datetime
                        v-else-if="'datetime' == column.type"
                        :id="column.id"
                        :value="item[column.id]"
                    >
                    </bo-cell-datetime>

                    <bo-cell-number
                        v-else-if="'number' == column.type"
                        class="w-100"
                        :id="column.id"
                        :meta="column.meta"
                        :decimal="column.decimal"
                        :currency="column.currency"
                        :negative="column.negative"
                        :sign="column.sign"
                        :min="column.min"
                        :max="column.maxTransform(item)"
                        :displayMax="column.displayMax"
                        :editable="column.editable"
                        :value="column.transform(item)"
                        :eager="column.eager"
                    >
                    </bo-cell-number>

                    <bo-cell-currency
                        v-else-if="'currency' == column.type"
                        :id="column.id"
                        :currency="'RM'"
                        :value="item[column.id]"
                        :meta="column.meta"
                        :editable="column.editable"
                    >
                    </bo-cell-currency>

                    <bo-cell-product
                        v-else-if="'product' == column.type"
                        editable="false"
                        :value="item[column.id]"
                    >
                    </bo-cell-product>

                    <bo-cell-multiselect
                        v-else-if="'multiselect' == column.type"
                        :ref="'assignDocument_' + id"
                        :id="column.id"
                        :parentId="id"
                        :value="item[column.id]"
                        :meta="column.meta"
                        :editable="column.editable"
                    ></bo-cell-multiselect>

                    <bo-cell-per-total
                        v-else-if="'per_total' == column.type"
                        :ref="'perTotal_' + id"
                        :id="column.id"
                        :parentId="id"
                        :meta="column.meta"
                        :editable="column.editable"
                        :value="item[column.id]"
                    >
                    </bo-cell-per-total>

                    <bo-cell-user
                        v-else-if="'user' == column.type"
                        :id="column.id"
                        :value="item[column.id]"
                    >
                    </bo-cell-user>

                    <bo-cell-link
                        v-else-if="'link' == column.type"
                        :id="column.id"
                        :link="item[column.id] ? item[column.id].link : null"
                        :label="item[column.id] ? item[column.id].label : null"
                        :target="item[column.id] ? item[column.id].target : null"
                    >
                    </bo-cell-link>

                    <bo-cell-attachment
                        v-else-if="'attachment' == column.type"
                        :value="item[column.id]"
                        :id="column.id"
                        :editable="column.editable"
                        @loading="$emit('loading')"
                        @done_loading="$emit('done_loading')"
                    >
                    </bo-cell-attachment>

                    <bo-cell-mode-input-number
                        v-else-if="'mode_input_number' == column.type"
                        :id="column.id"
                        class="form-control"
                        :value="item[column.id].value"
                        :options="item[column.id].options"
                        :selected="item[column.id].selected"
                        :meta="column.meta"
                        :editable="column.editable"
                    >
                    </bo-cell-mode-input-number>

                    <slot
                        v-else
                        :name="column.id"
                    >
                        <div
                            class="d-flex align-items-center"
                            :id="column.id"
                        >
                            <span>{{
                                typeof column.transform != "undefined" ? column.transform(item) : item[column.id]
                            }}</span>
                        </div>
                    </slot>
                </template>
            </td>
        </template>
        <td
            v-if="deleteRow"
            class="row-action-cell"
        >
            <i
                class="icon-arclight icon-deleteforever remove"
                @click="deleteSubrecord(id)"
            ></i>
        </td>
        <td
            v-else-if="showSubrecordActionMenu"
            class="row-action-cell"
        ></td>
        <td style="min-width: 1px">
            <!-- spacer -->
        </td>
    </tr>
</template>

<script>
export default {
    props: ["columns", "item", "prepend", "id", "deleteRow", "showSubrecordActionMenu", "rowClass"],

    methods: {
        resolveURL(rawUrl, item) {
            return this.resolvePlaceholders(rawUrl, item);
        },

        resolvePlaceholders(str, record) {
            const array = str.matchAll(/~~(\w*)~~/g);

            for (const group of array) {
                if (group[1] in record) {
                    str = str.replace(new RegExp("~~" + group[1] + "~~", "g"), record[group[1]]);
                }
            }

            return str;
        },

        deleteSubrecord(id) {
            this.$emit("delete", id);
        },
    },
};
</script>
